(function () {
  'use strict';

  var root = document.querySelector('[data-devid-assistant-v2]');
  if (!root || window.DevidAssistantCommerceV5) return;

  var A = window.DevidAssistantCommerceV5 = { root: root };
  A.form = root.querySelector('[data-assistant-form]');
  A.input = root.querySelector('[data-assistant-input]');
  A.messages = root.querySelector('[data-assistant-messages]');
  A.content = root.querySelector('[data-assistant-content]');
  A.quick = root.querySelector('[data-assistant-quick-strip]');
  A.resetButton = root.querySelector('[data-assistant-reset]');
  A.accountUrl = (root.getAttribute('data-account-url') || '').trim();
  A.locale = (root.getAttribute('data-locale') || 'it').toLowerCase();
  A.en = A.locale.indexOf('en') === 0;
  A.shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  A.copy = A.en ? {
    returnTitle: 'Return or size exchange',
    returnText: 'Sign in with the email used for your order. You’ll receive a 6-digit verification code, so there is no password to remember.',
    account: 'Open my orders',
    productTitle: 'Let’s find the right piece',
    category: 'What are you looking for?',
    gender: 'Is it for men or women?',
    fit: 'How would you like it to fit?',
    loading: 'One moment, I’m finding the best options for you…',
    results: 'You might like these',
    resultText: 'I picked a few pieces that match what you’re looking for. Scroll through them and open the ones you’d like to see more closely.',
    none: 'I can’t find an option I would genuinely recommend right now. Shall we try another item?',
    lookTitle: 'Let’s create your look',
    lookItem: 'Which piece would you like to start with?',
    lookLoading: 'One moment, I’m finding the right match…',
    lookResult: 'This look works',
    lookText: 'These two pieces work well together and follow the preferences you shared.',
    noLook: 'I couldn’t find a combination I would genuinely recommend for this search. Shall we start with another piece?',
    again: 'Choose another item',
    size: 'Choose size',
    available: 'Available',
    add: 'Add',
    adding: 'Adding…',
    added: 'Added',
    view: 'View product',
    pair: 'Complete the look',
    pairTitle: 'Complete the look',
    pairText: 'This piece works especially well with the item you selected.',
    addBoth: 'Add the look',
    error: 'Something went wrong. Please try again shortly.',
    categories: ['Trousers', 'T-shirts and polos', 'Jackets', 'Accessories'],
    genders: ['Men', 'Women'],
    fits: ['Comfortable', 'Regular', 'Slimmer'],
    lookItems: ['White polo', 'T-shirt', 'Sweatshirt', 'Trousers', 'Jacket']
  } : {
    returnTitle: 'Reso o cambio taglia',
    returnText: 'Accedi con l’e-mail usata per l’ordine. Riceverai un codice di verifica di 6 cifre, senza dover ricordare alcuna password.',
    account: 'Vai ai miei ordini',
    productTitle: 'Ti aiuto a scegliere',
    category: 'Quale capo stai cercando?',
    gender: 'Lo cerchi da uomo o da donna?',
    fit: 'Come preferisci che vesta?',
    loading: 'Un attimo, cerco le proposte più adatte a te…',
    results: 'Potrebbero piacerti',
    resultText: 'Ho selezionato alcuni capi che rispecchiano la tua ricerca. Scorri le proposte e apri quelle che vuoi vedere meglio.',
    none: 'In questo momento non trovo una proposta che ti consiglierei davvero. Proviamo con un altro capo?',
    lookTitle: 'Creiamo il tuo look',
    lookItem: 'Da quale capo vuoi partire?',
    lookLoading: 'Un attimo, cerco l’abbinamento giusto…',
    lookResult: 'Questo look funziona',
    lookText: 'Questi due capi stanno bene insieme e seguono le preferenze che mi hai indicato.',
    noLook: 'Per questa ricerca non ho trovato un abbinamento che ti consiglierei davvero. Proviamo a partire da un altro capo?',
    again: 'Scegli un altro capo',
    size: 'Scegli taglia',
    available: 'Disponibile',
    add: 'Aggiungi',
    adding: 'Aggiunta…',
    added: 'Aggiunto',
    view: 'Vedi prodotto',
    pair: 'Completa il look',
    pairTitle: 'Completa il look',
    pairText: 'Questo capo completa bene la proposta che hai scelto.',
    addBoth: 'Aggiungi il look',
    error: 'Qualcosa non ha funzionato. Riprova tra poco.',
    categories: ['Pantaloni', 'T-shirt e polo', 'Giacche', 'Accessori'],
    genders: ['Uomo', 'Donna'],
    fits: ['Comoda', 'Regolare', 'Più aderente'],
    lookItems: ['Polo bianca', 'T-shirt', 'Felpa', 'Pantalone', 'Giacca']
  };

  A.state = { flow: null, stage: null, request: '', category: '', gender: '', fit: '', busy: false };

  A.n = function (value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  A.reset = function () {
    A.state = { flow: null, stage: null, request: '', category: '', gender: '', fit: '', busy: false };
  };

  A.scroll = function () {
    if (A.content) requestAnimationFrame(function () {
      A.content.scrollTop = A.content.scrollHeight;
    });
  };

  A.emit = function (name, detail) {
    var payload = Object.assign({ event: name, assistant: 'devid_assistant_v2', module: 'commerce_v5' }, detail || {});
    window.dispatchEvent(new CustomEvent('devid:assistant', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  };

  A.user = function (text) {
    A.root.classList.add('has-conversation');
    if (A.quick) A.quick.hidden = false;
    var article = document.createElement('article');
    var bubble = document.createElement('div');
    article.className = 'devid-assistant-v2__message devid-assistant-v2__message--user';
    bubble.className = 'devid-assistant-v2__bubble';
    bubble.textContent = text;
    article.appendChild(bubble);
    A.messages.appendChild(article);
    A.scroll();
  };

  A.assistant = function (title, text) {
    A.root.classList.add('has-conversation');
    if (A.quick) A.quick.hidden = false;
    var article = document.createElement('article');
    var stack = document.createElement('div');
    var bubble = document.createElement('div');
    article.className = 'devid-assistant-v2__message devid-assistant-v2__message--assistant devid-assistant-v2__message--concierge';
    stack.className = 'devid-assistant-v2__message-stack';
    bubble.className = 'devid-assistant-v2__bubble';
    if (title) {
      var heading = document.createElement('strong');
      heading.className = 'devid-assistant-v2__bubble-title';
      heading.textContent = title;
      bubble.appendChild(heading);
    }
    if (text) {
      var paragraph = document.createElement('p');
      paragraph.textContent = text;
      bubble.appendChild(paragraph);
    }
    stack.appendChild(bubble);
    article.appendChild(stack);
    A.messages.appendChild(article);
    return { article: article, stack: stack, bubble: bubble };
  };

  A.replies = function (stack, labels, callback) {
    if (!labels || !labels.length) return;
    var replies = document.createElement('div');
    replies.className = 'devid-assistant-v2__replies devid-assistant-v2__replies--concierge';
    labels.forEach(function (label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'devid-assistant-v2__reply';
      button.textContent = label;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        callback(label);
      });
      replies.appendChild(button);
    });
    stack.appendChild(replies);
  };

  A.ask = function (title, text, labels, callback) {
    var message = A.assistant(title, text);
    A.replies(message.stack, labels, callback);
    A.scroll();
    return message;
  };

  A.loading = function (text) {
    var message = A.assistant('', text);
    var dots = document.createElement('span');
    dots.className = 'devid-assistant-v2__typing';
    dots.innerHTML = '<span></span><span></span><span></span>';
    message.bubble.appendChild(dots);
    A.scroll();
    return message.article;
  };

  A.remove = function (node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  };

  A.category = function (text) {
    var value = A.n(text);
    if (/\b(giacca|giacche|jacket|k-way|kway|piumino|cappotto|blazer|outerwear|parka|trench)\b/.test(value)) return 'outerwear';
    if (/\b(pantalon[ei]?|cargo|jeans|denim|chino|carpenter|jogger)\b/.test(value)) return 'pants';
    if (/\b(t shirt|tshirt|t-shirt|polo|maglia|top|camicia|felpa|felpe|hoodie|sweatshirt|fleece|maglieria)\b/.test(value)) return 'tops';
    if (/\b(costume|mare|beachwear|bermuda|short|shorts)\b/.test(value)) return 'summer';
    if (/\b(zaino|borsa|pochette|portafoglio|cappello|scarpe|sneaker|accessori)\b/.test(value)) return 'accessories';
    return '';
  };

  A.gender = function (text) {
    var value = A.n(text);
    if (/\b(donna|woman|women|femminile|lady)\b/.test(value)) return 'women';
    if (/\b(uomo|man|men|maschile)\b/.test(value)) return 'men';
    return '';
  };

  A.isReturn = function (text) {
    return /\b(reso|resi|cambio taglia|restituire|return|returns|exchange)\b/.test(A.n(text));
  };

  A.isLook = function (text) {
    return /\b(look|outfit|abbina|abbinamento|consigliami un look|crea un look|style me|build a look)\b/.test(A.n(text));
  };

  A.isProduct = function (text) {
    return Boolean(A.category(text)) || /\b(aiutami a scegliere|consiglio prodotto|cerco un prodotto|prodotto giusto|recommend|product advice)\b/.test(A.n(text));
  };

  A.collections = function (product) {
    return Array.isArray(product && product.collections)
      ? product.collections.map(function (collection) {
        return A.n((collection && collection.handle) || '') + ' ' + A.n((collection && collection.title) || '');
      }).join(' ')
      : '';
  };

  A.hay = function (product) {
    return A.n([
      product && product.title,
      product && product.model,
      product && product.vendor,
      product && product.product_type,
      product && product.department,
      product && product.fit,
      product && product.description,
      Array.isArray(product && product.tags) ? product.tags.join(' ') : '',
      A.collections(product)
    ].join(' '));
  };

  A.department = function (product) {
    var department = A.n(product && product.department);
    var haystack = A.hay(product);
    if (/^(woman|women|donna|female|femminile)$/.test(department)) return 'women';
    if (/^(man|men|uomo|male|maschile)$/.test(department)) return 'men';
    if (/unisex/.test(department)) return 'unisex';
    if (/\b(ponza|courmayeur|globe|mirtos|alassio)\b/.test(haystack)) return 'men';
    var women = /\b(donna|women|woman|femminile|lady)\b/.test(haystack);
    var men = /\b(uomo|men|man|maschile)\b/.test(haystack);
    if (women && !men) return 'women';
    if (men && !women) return 'men';
    return /\bunisex\b/.test(haystack) ? 'unisex' : '';
  };

  A.genderOK = function (product, gender) {
    var department = A.department(product);
    return Boolean(department) && (department === gender || department === 'unisex');
  };

  A.detectedCategory = function (product) {
    var haystack = A.hay(product);
    if (/\b(giacca|giacche|jacket|k-way|kway|piumino|cappotto|blazer|outerwear|parka|trench)\b/.test(haystack)) return 'outerwear';
    if (/\b(pantalon[ei]?|cargo|jeans|denim|chino|carpenter|jogger)\b/.test(haystack)) return 'pants';
    if (/\b(t shirt|tshirt|t-shirt|polo|maglia|top|camicia|felpa|felpe|hoodie|sweatshirt|fleece|maglieria)\b/.test(haystack)) return 'tops';
    if (/\b(costume|swim|beachwear|bermuda|short|shorts)\b/.test(haystack)) return 'summer';
    if (/\b(zaino|borsa|pochette|portafoglio|cappello|scarpe|sneaker|accessori)\b/.test(haystack)) return 'accessories';
    return '';
  };

  A.categoryOK = function (product, category) {
    return A.detectedCategory(product) === category;
  };

  A.variantsOK = function (product) {
    return Boolean(product && Array.isArray(product.variants) && product.variants.length);
  };

  A.requestSubtype = function (text) {
    var value = A.n(text);
    if (/\b(felpa|felpe|hoodie|sweatshirt|fleece)\b/.test(value)) return 'sweatshirt';
    if (/\b(polo)\b/.test(value)) return 'polo';
    if (/\b(t shirt|tshirt|t-shirt|tee)\b/.test(value)) return 'tshirt';
    if (/\b(camicia|shirt)\b/.test(value)) return 'shirt';
    if (/\b(maglia|maglieria|knit|sweater|cardigan)\b/.test(value)) return 'knitwear';
    if (/\b(cargo)\b/.test(value)) return 'cargo';
    if (/\b(jeans|denim)\b/.test(value)) return 'jeans';
    if (/\b(chino)\b/.test(value)) return 'chino';
    if (/\b(jogger|pantalone in felpa|pantaloni in felpa)\b/.test(value)) return 'jogger';
    return '';
  };

  A.productSubtype = function (product) {
    var haystack = A.hay(product);
    if (/\b(felpa|felpe|hoodie|sweatshirt|fleece)\b/.test(haystack)) return 'sweatshirt';
    if (/\b(polo)\b/.test(haystack)) return 'polo';
    if (/\b(t shirt|tshirt|t-shirt|tee)\b/.test(haystack)) return 'tshirt';
    if (/\b(camicia|shirt)\b/.test(haystack)) return 'shirt';
    if (/\b(cardigan|maglieria|knit|sweater|maglia)\b/.test(haystack)) return 'knitwear';
    if (/\b(cargo)\b/.test(haystack)) return 'cargo';
    if (/\b(jeans|denim)\b/.test(haystack)) return 'jeans';
    if (/\b(chino)\b/.test(haystack)) return 'chino';
    if (/\b(jogger|pantalone in felpa|pantaloni in felpa)\b/.test(haystack)) return 'jogger';
    return '';
  };

  A.subtypeOK = function (product, request) {
    var requested = A.requestSubtype(request);
    return !requested || A.productSubtype(product) === requested;
  };

  A.vendorRequested = function (text) {
    var value = A.n(text);
    var known = [
      'devid label', 'replay', 'mc2 saint barth', 'saint barth', 'manila grace', 'manila',
      'g-star', 'g star', 'juicy couture', 'k-way', 'kway', 'sprayground', 'polo ralph lauren',
      'ralph lauren', 'marcelo burlon', 'refrigiwear', 'distretto 12'
    ];
    for (var index = 0; index < known.length; index += 1) {
      if (value.indexOf(known[index]) >= 0) return known[index];
    }
    return '';
  };

  A.isLastChance = function (product) {
    return /\b(last chance|last-chance|devid-label-last-chance)\b/.test(A.hay(product));
  };

  A.fitScore = function (product, fit) {
    var haystack = A.hay(product);
    var normalizedFit = A.n(fit);
    if (!normalizedFit) return 0;
    if (/comoda|comfortable/.test(normalizedFit)) {
      return /\b(comfort|comoda|relax|relaxed|regular|morbido|stretch|elast|cargo|palazzo|wide|jogger|felpa|fleece|oversize|loose)\b/.test(haystack) ? 14 : 0;
    }
    if (/regolare|regular/.test(normalizedFit)) {
      return /\b(regular|regolare|classic|normale|straight)\b/.test(haystack) ? 12 : 0;
    }
    if (/aderente|slimmer|slim/.test(normalizedFit)) {
      return /\b(slim|aderente|fitted|skinny|tapered|affusolat)\b/.test(haystack) ? 14 : 0;
    }
    return 0;
  };

  A.score = function (product, request, gender, category, fit) {
    var haystack = A.hay(product);
    var query = A.n(request);
    var score = 0;
    if (A.categoryOK(product, category)) score += 30;
    if (A.genderOK(product, gender)) score += 30;
    if (A.n(product.vendor) === 'devid label') score += 4;
    query.split(' ').filter(function (word) {
      return word.length > 3;
    }).forEach(function (word) {
      if (haystack.indexOf(word) >= 0) score += 2;
    });
    if (/bianc|white/.test(query) && /bianc|white|panna|avorio/.test(haystack)) score += 8;
    var requestedSubtype = A.requestSubtype(request);
    if (requestedSubtype) score += A.productSubtype(product) === requestedSubtype ? 20 : -30;
    score += A.fitScore(product, fit);
    return A.variantsOK(product) ? score : score - 100;
  };

  A.modelKey = function (product) {
    return A.n(product.model || product.handle || product.title)
      .replace(/\b(nero|nera|black|bianco|bianca|white|blu|blue|navy|beige|sabbia|verde|green|rosa|pink|rosso|red)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  A.unique = function (products) {
    var seen = {};
    return products.filter(function (product) {
      var key = A.modelKey(product);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  A.selectMixedProducts = function (products, request, gender, category, fit) {
    var wanted = A.vendorRequested(request);
    var valid = A.unique(products.filter(A.variantsOK).filter(function (product) {
      return A.genderOK(product, gender) && A.categoryOK(product, category) && A.subtypeOK(product, request);
    }).sort(function (first, second) {
      return A.score(second, request, gender, category, fit) - A.score(first, request, gender, category, fit);
    }));

    if (wanted) {
      var matches = valid.filter(function (product) {
        return A.n(product.vendor).indexOf(wanted) >= 0 || wanted.indexOf(A.n(product.vendor)) >= 0;
      });
      if (matches.length) return matches.slice(0, 5);
    }

    var devidLabel = valid.filter(function (product) {
      return A.n(product.vendor) === 'devid label';
    }).slice(0, 2);
    var external = valid.filter(function (product) {
      return A.n(product.vendor) !== 'devid label';
    });
    var vendors = {};
    var mixed = devidLabel.slice();

    external.forEach(function (product) {
      var vendor = A.n(product.vendor);
      if (mixed.length < 5 && vendor && !vendors[vendor]) {
        vendors[vendor] = true;
        mixed.push(product);
      }
    });

    if (mixed.length < 5) valid.forEach(function (product) {
      if (mixed.length < 5 && mixed.indexOf(product) < 0) mixed.push(product);
    });

    return mixed.slice(0, 5);
  };

  A.queries = function (category, gender, request, fit) {
    var genderLabel = gender === 'women'
      ? (A.en ? 'women' : 'donna')
      : (A.en ? 'men' : 'uomo');
    var subtype = A.requestSubtype(request);
    var comfortable = /comoda|comfortable/.test(A.n(fit));
    var queries = [];

    if (request) queries.push(request + ' ' + genderLabel);

    if (subtype === 'sweatshirt') {
      queries = queries.concat([
        (A.en ? 'sweatshirt ' : 'felpa ') + genderLabel,
        'hoodie ' + genderLabel,
        'fleece ' + genderLabel,
        'Polo Ralph Lauren ' + (A.en ? 'sweatshirt ' : 'felpa ') + genderLabel,
        'Marcelo Burlon ' + (A.en ? 'sweatshirt ' : 'felpa ') + genderLabel,
        'Refrigiwear ' + (A.en ? 'sweatshirt ' : 'felpa ') + genderLabel
      ]);
    } else if (subtype === 'polo') {
      queries = queries.concat(['polo ' + genderLabel, 'MC2 Saint Barth polo ' + genderLabel, 'Devid Label polo ' + genderLabel]);
    } else if (subtype === 'tshirt') {
      queries = queries.concat(['t-shirt ' + genderLabel, 'MC2 Saint Barth t-shirt ' + genderLabel, 'Devid Label t-shirt ' + genderLabel, 'Replay t-shirt ' + genderLabel]);
    } else if (category === 'pants') {
      if (comfortable) {
        queries = queries.concat([
          (A.en ? 'comfortable trousers ' : 'pantalone comodo ') + genderLabel,
          'cargo ' + genderLabel,
          gender === 'women' ? 'Portorico donna' : 'cargo uomo'
        ]);
      }
      queries = queries.concat([
        (A.en ? 'trousers ' : 'pantaloni ') + genderLabel,
        'jeans ' + genderLabel,
        'Devid Label ' + (A.en ? 'trousers ' : 'pantaloni ') + genderLabel,
        'Replay ' + genderLabel,
        'MC2 Saint Barth ' + genderLabel,
        'Manila Grace ' + genderLabel
      ]);
    } else if (category === 'tops') {
      queries = queries.concat([
        't-shirt polo ' + genderLabel,
        (A.en ? 'sweatshirt ' : 'felpa ') + genderLabel,
        'Devid Label t-shirt ' + genderLabel,
        'Replay ' + genderLabel,
        'MC2 Saint Barth ' + genderLabel,
        'Manila Grace ' + genderLabel
      ]);
    } else if (category === 'outerwear') {
      queries = queries.concat([
        (A.en ? 'jacket ' : 'giacca ') + genderLabel,
        'K-Way ' + genderLabel,
        'Devid Label ' + (A.en ? 'jacket ' : 'giacca ') + genderLabel,
        'Replay ' + (A.en ? 'jacket ' : 'giacca ') + genderLabel
      ]);
    } else if (category === 'summer') {
      queries = queries.concat([
        (A.en ? 'beachwear ' : 'mare ') + genderLabel,
        (A.en ? 'swimwear ' : 'costume ') + genderLabel,
        'bermuda ' + genderLabel
      ]);
    } else {
      queries = queries.concat([
        (A.en ? 'accessories ' : 'accessori ') + genderLabel,
        (A.en ? 'bag ' : 'borsa ') + genderLabel,
        (A.en ? 'backpack ' : 'zaino ') + genderLabel
      ]);
    }

    var wanted = A.vendorRequested(request);
    if (wanted) queries.unshift(request + ' ' + genderLabel, wanted + ' ' + genderLabel);

    var seen = {};
    return queries.filter(function (query) {
      var key = A.n(query);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 9);
  };

  A.feed = async function (query) {
    var response = await fetch(A.shopRoot + 'search?view=assistant&type=product&q=' + encodeURIComponent(query), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json, text/plain, */*' }
    });
    if (!response.ok) throw new Error('assistant_feed_' + response.status);
    var data = JSON.parse((await response.text()).trim());
    return data && Array.isArray(data.products) ? data.products : [];
  };

  A.fetchProducts = async function (category, gender, request, fit) {
    var groups = await Promise.all(A.queries(category, gender, request, fit).map(function (query) {
      return A.feed(query).catch(function () { return []; });
    }));
    var all = groups.flat();
    var seen = {};
    return all.filter(function (product) {
      var key = product && (product.id || product.handle);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  A.complementary = function (first, second) {
    var firstCategory = A.detectedCategory(first);
    var secondCategory = A.detectedCategory(second);
    if (!firstCategory || !secondCategory || firstCategory === secondCategory) return false;
    if (firstCategory === 'outerwear') return secondCategory === 'tops' || secondCategory === 'pants';
    if (firstCategory === 'pants') return secondCategory === 'tops' || secondCategory === 'outerwear';
    if (firstCategory === 'tops') return secondCategory === 'pants' || secondCategory === 'outerwear';
    if (firstCategory === 'summer') return secondCategory === 'tops' || secondCategory === 'accessories';
    return true;
  };

  A.sameProduct = function (first, second) {
    if (!first || !second) return false;
    if (first.id && second.id && String(first.id) === String(second.id)) return true;
    return Boolean(first.handle && second.handle && first.handle === second.handle);
  };

  A.partnerCompatible = function (base, partner, gender) {
    return Boolean(
      partner &&
      A.variantsOK(partner) &&
      A.genderOK(partner, gender) &&
      A.complementary(base, partner) &&
      !A.sameProduct(base, partner)
    );
  };

  A.partnerCategories = function (base) {
    var category = A.detectedCategory(base);
    if (category === 'pants') return ['tops'];
    if (category === 'tops') return ['pants'];
    if (category === 'outerwear') return ['tops', 'pants'];
    if (category === 'summer') return ['tops', 'accessories'];
    if (category === 'accessories') return ['tops'];
    return [];
  };

  A.partnerRequest = function (base) {
    var category = A.detectedCategory(base);
    var subtype = A.productSubtype(base);
    if (category === 'pants') return A.en ? 't-shirt or polo' : 't-shirt o polo';
    if (category === 'tops' && subtype === 'sweatshirt') return A.en ? 'casual trousers' : 'pantalone casual';
    if (category === 'tops') return A.en ? 'trousers' : 'pantalone';
    if (category === 'outerwear') return A.en ? 't-shirt' : 't-shirt';
    if (category === 'summer') return A.en ? 't-shirt' : 't-shirt';
    return A.en ? 'top' : 'maglia';
  };

  A.partnerVendorScore = function (base, partner, gender) {
    var baseVendor = A.n(base && base.vendor);
    var partnerVendor = A.n(partner && partner.vendor);
    var score = baseVendor && partnerVendor && baseVendor !== partnerVendor ? 10 : 0;

    if (baseVendor === 'devid label' && partnerVendor !== 'devid label') score += 8;
    if (baseVendor !== 'devid label' && partnerVendor === 'devid label') score += 5;

    if (gender === 'women' && A.detectedCategory(partner) === 'tops') {
      if (/mc2 saint barth|saint barth/.test(partnerVendor)) score += 10;
      else if (/manila grace/.test(partnerVendor)) score += 7;
      else if (/replay/.test(partnerVendor)) score += 5;
    }

    if (gender === 'men' && A.detectedCategory(partner) === 'pants') {
      if (/devid label/.test(partnerVendor)) score += 8;
      else if (/replay|g-star|g star/.test(partnerVendor)) score += 7;
      else if (/distretto 12/.test(partnerVendor)) score += 5;
    }

    return score;
  };

  A.partnerScore = function (base, partner, gender) {
    var score = 0;
    if (A.genderOK(partner, gender)) score += 30;
    if (A.complementary(base, partner)) score += 30;
    score += A.partnerVendorScore(base, partner, gender);

    var baseCategory = A.detectedCategory(base);
    var partnerSubtype = A.productSubtype(partner);
    if (baseCategory === 'pants' && (partnerSubtype === 'tshirt' || partnerSubtype === 'polo')) score += 12;
    if (A.productSubtype(base) === 'sweatshirt' && A.detectedCategory(partner) === 'pants') score += 12;

    var haystack = A.hay(partner);
    if (/\b(nero|black|bianco|white|navy|blu|blue|beige|sabbia|grey|grigio)\b/.test(haystack)) score += 3;
    return score;
  };

  A.selectDynamicPartner = function (base, products, gender) {
    var candidates = A.unique(products.filter(function (product) {
      return A.partnerCompatible(base, product, gender);
    })).sort(function (first, second) {
      return A.partnerScore(base, second, gender) - A.partnerScore(base, first, gender);
    });
    return candidates[0] || null;
  };

  A.lookBases = function (products, request, gender, category, fit) {
    return A.unique(products.filter(A.variantsOK).filter(function (product) {
      return A.categoryOK(product, category) && A.genderOK(product, gender) && A.subtypeOK(product, request);
    }).sort(function (first, second) {
      return A.score(second, request, gender, category, fit) - A.score(first, request, gender, category, fit);
    }));
  };

  A.findLookPair = async function (category, gender, request, fit) {
    var baseProducts = await A.fetchProducts(category, gender, request, fit);
    var bases = A.lookBases(baseProducts, request, gender, category, fit);

    for (var configuredIndex = 0; configuredIndex < bases.length; configuredIndex += 1) {
      var configuredBase = bases[configuredIndex];
      if (A.partnerCompatible(configuredBase, configuredBase.bundle_partner, gender)) return configuredBase;
    }

    var partnerCache = {};
    for (var baseIndex = 0; baseIndex < bases.length; baseIndex += 1) {
      var base = bases[baseIndex];
      var categories = A.partnerCategories(base);
      var partnerPool = [];

      for (var categoryIndex = 0; categoryIndex < categories.length; categoryIndex += 1) {
        var partnerCategory = categories[categoryIndex];
        if (!partnerCache[partnerCategory]) {
          partnerCache[partnerCategory] = await A.fetchProducts(
            partnerCategory,
            gender,
            A.partnerRequest(base),
            ''
          );
        }
        partnerPool = partnerPool.concat(partnerCache[partnerCategory]);
      }

      var dynamicPartner = A.selectDynamicPartner(base, partnerPool, gender);
      if (dynamicPartner) {
        return Object.assign({}, base, {
          bundle_partner: dynamicPartner,
          assistant_pair_source: 'dynamic_catalog'
        });
      }
    }

    return null;
  };
})();
